export enum GeneralIcon {
  AppWindow = 'AppWindow',
  Stack = 'Stack',
  Cpu = 'Cpu',
  Database = 'Database',
  HardDrive = 'HardDrive',
  Upload = 'Upload',
  Download = 'Download',
  ShieldCheck = 'ShieldCheck',
  ShieldWarning = 'ShieldWarning',
  Heartbeat = 'Heartbeat',
  Activity = 'Activity',
  Monitor = 'Monitor',
  Terminal = 'Terminal',
  Gear = 'Gear',
  Wrench = 'Wrench',
  File = 'File',
  FileArrowDown = 'FileArrowDown',
  FileArrowUp = 'FileArrowUp',
  FileLock = 'FileLock',
  Folder = 'Folder',
  FolderNotch = 'FolderNotch',
  FolderOpen = 'FolderOpen',
  FloppyDisk = 'FloppyDisk',
  Rocket = 'Rocket',
  Circuitry = 'Circuitry',
  Network = 'Network',
  Link = 'Link',
  Plug = 'Plug',
  Power = 'Power',
  Warning = 'Warning',
  Bug = 'Bug',
  WindowsLogo = 'WindowsLogo',
  AppleLogo = 'AppleLogo',
  LinuxLogo = 'LinuxLogo',
  Clipboard = 'Clipboard',
  Timer = 'Timer',
  Lock = 'Lock',
  Key = 'Key',
  Recycle = 'Recycle',
  ArrowsCounterClockwise = 'ArrowsCounterClockwise',
  Eye = 'Eye',
  Fire = 'Fire',
  Flag = 'Flag',
  Globe = 'Globe',
  Hand = 'Hand',
  MapPin = 'MapPin',
  Moon = 'Moon',
  Paperclip = 'Paperclip',
  Pen = 'Pen',
  Phone = 'Phone',
  Shield = 'Shield',
  Sun = 'Sun',
  Trophy = 'Trophy',
  User = 'User',
  Cloud = 'Cloud',
  DownloadSimple = 'DownloadSimple',
  AirTrafficControl = 'AirTrafficControl',
  WarningCircle = 'WarningCircle',
  Laptop = 'Laptop',
  ClipboardText = 'ClipboardText',
  SecurityCamera = 'SecurityCamera',
  Barcode = 'Barcode',
  Cube = 'Cube',
  Browser = 'Browser',
  Desktop = 'Desktop',
  DeviceMobile = 'DeviceMobile',
  GameController = 'GameController',
  ChartBar = 'ChartBar',
  Robot = 'Robot',
  Storefront = 'Storefront',
  UsersThree = 'UsersThree',
  VideoCamera = 'VideoCamera',
  Plus = 'Plus',
  SelectionAll = 'SelectionAll'
}
